import Vue from 'vue'
import VueYandexMetrika from 'vue-yandex-metrika'
if (process.env.VUE_APP_YANDEX_METRIKA) {
    if (!location.href.includes('reg.ru/domain/shop/lot')) {
        Vue.use(VueYandexMetrika, {
            id: process.env.VUE_APP_YANDEX_METRIKA,
            //debug: true,
            //env: process.env.NODE_ENV,
            env: 'production',
            options: {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true
            }
        })
    }
}
